import { combineTokens } from '@utils/css';

const tokens = combineTokens("--progress-bar", {
  filled: "0",
  dragHandleOffset: "0%"
});
const container = "_35sc1204gwa";
const dragHandle = "_35sdan7dnw";

export { container, dragHandle, tokens };
import "./atom.progress-bar.style.linaria.module.css";
//# sourceMappingURL=atom.progress-bar.style.js.map
